import request from '@/utils/axios'

let base = '/backend/auth'

/**
 * 注册验证码
 */
export const register = () => {
  return request({
    url: `${base}/jigsaw/captcha/register`,
    method: 'get'
  })
}

/**
 * 拼图校验与登录
 */
export const check = form => {
  return request({
    url: `${base}/jigsaw/captcha/check`,
    headers: {
      'Authorization': 'Basic Y2xvdWRhcHA6MTIzNDU2'
    },
    method: 'post',
    data: form
  })
}



// WEBPACK FOOTER //
// ./src/api/system/auth/jigsawCaptcha.js